type OnboardingConfig = {
  storageKey: string;
  steps: string[];
  texts: string[];
};

export const onboardingConfigs: Record<number, OnboardingConfig> = {
  1: {
    storageKey: 'onboarding:market-signal',
    steps: [
      '.market-signal-search',
      '.market-signal-size',
      '.market-signal-stoploss',
      '.market-signal-type',
      '.market-signal-comment',
      '.market-signal-submit',
    ],
    texts: [
      'Введите инструмент в поле поиска (тикер или название).',
      'Укажите вес сигнала в %.',
      'Если необходимо, задайте уровни Stop Loss и Take Profit.',
      'Выберите тип сигнала — покупка для long позиции или для уменьшения short позиции, продажа для short позиции или уменьшения long, закрытие чтобы полностью закрыть текущую позицию в стратегии.',
      'Можете оставить комментарий — это заметка по сигналу, будет доступна вам в истории сделок.',
      'Нажмите сформировать сигнал чтобы выставить сигнал по стратегии.',
    ],
  },
  2: {
    storageKey: 'onboarding:delayed-signal',
    steps: [
      '.delayed-signal-search',
      '.delayed-signal-size',
      '.delayed-signal-price',
      '.delayed-signal-stoploss',
      '.delayed-signal-timeout',
      '.delayed-signal-type',
      '.delayed-signal-comment',
      '.delayed-signal-submit',
    ],
    texts: [
      'Введите инструмент в поле поиска (тикер или название).',
      'Укажите вес сигнала в %.',
      'Введите цену при достижении которой должен выставиться сигнал, эта же цена будет использована в заявке при выставлении на биржу.',
      'Если необходимо, задайте уровни Stop Loss и Take Profit.',
      'Укажите сколько минут должна стоять заявка на рынке после достижения цены — алгоритм будет перевыставлять заявки указанное количество минут по указанной цене.',
      'Выберите тип сигнала — покупка для long позиции или для уменьшения short позиции, продажа для short позиции или уменьшения long, закрытие чтобы полностью закрыть текущую позицию в стратегии.',
      'Можете оставить комментарий — это заметка по сигналу, будет доступна вам в истории сделок.',
      'Нажмите сформировать сигнал чтобы выставить сигнал по стратегии.',
    ],
  },
  3: {
    storageKey: 'onboarding:package-signal',
    steps: [
      '.package-signal-search',
      '.package-signal-size',
      '.package-signal-stoploss',
      '.package-signal-type',
      '.package-signal-comment',
      '.package-signal-add',
      '.package-signal-list',
      '.package-signal-submit',
    ],
    texts: [
      'Введите инструмент в поле поиска (тикер или название).',
      'Укажите вес сигнала в %.',
      'Если необходимо, задайте уровни Stop Loss и Take Profit.',
      'Выберите тип сигнала — покупка для long позиции или для уменьшения short позиции.',
      'Можете оставить комментарий — это заметка по сигналу, будет доступна вам в истории сделок.',
      'Нажмите добавить в список.',
      'Здесь отображается список всех сигналов, которые будут отправлены. Если необходимо, можно убрать сигнал из списка нажатием \u2A09.',
      'Нажмите сформировать сигнал чтобы выставить сигнал по стратегии.',
    ],
  },
  4: {
    storageKey: 'onboarding:portfolio-signal',
    steps: [
      '.portfolio-signal-list',
      '.portfolio-signal-edit',
      '.portfolio-signal-close',
      '.portfolio-signal-search',
      '.portfolio-signal-size',
      '.portfolio-signal-stoploss',
      '.portfolio-signal-type',
      '.portfolio-signal-submit',
    ],
    texts: [
      'В списке отображаются все текущие позиции по стратегии.',
      'Если вы хотите изменить текущую позицию, нажмите \u21C4.',
      'Если вы хотите закрыть текущую позицию, нажмите \u2A09.',
      'Для добавления новой позиции введите инструмент в поле поиска (тикер или название).',
      'Укажите вес позиции в %.',
      'Если необходимо, задайте уровни Stop Loss и Take Profit.',
      'Укажите направление позиции — Покупка для long и Продажа для short.',
      'Нажмите сформировать сигнал чтобы выставить сигналы по стратегии — состав портфеля стратегии станет идентичен списку.',
    ],
  },
  5: {
    storageKey: 'onboarding:limit-signal',
    steps: [
      '.limit-order-search-field',
      '.limit-order-size',
      '.limit-order-book',
      '.limit-order-price',
      '.limit-order-timeout',
      '.limit-order-type',
      '.limit-order-comment',
      '.limit-order-submit',
    ],
    texts: [
      'Введите инструмент в поле поиска (тикер или название).',
      'Укажите вес сигнала в %.',
      'По клику на котировку можно выбрать цену для сигнала.',
      'Цену также можно ввести в это поле, но цена не должна выходить за границы стакана котировок.',
      'Укажите сколько времени должна стоять заявка на бирже по указанной цене.',
      'Выберите тип сигнала — покупка для long позиции или для уменьшения short позиции, продажа для short позиции или уменьшения long, закрытие чтобы полностью закрыть текущую позицию в стратегии.',
      'Можете оставить комментарий — это заметка по сигналу, будет доступна вам в истории сделок.',
      'Нажмите сформировать сигнал чтобы выставить сигнал по стратегии.',
    ],
  },
};
